/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Elecconso1Inputs */



/**
* | output |
* | --- |
* | "Electric consumption" |
*
* @param {Br_History_Key_Elecconso1Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_elecconso1 = /** @type {((inputs?: Br_History_Key_Elecconso1Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Elecconso1Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Electric consumption")
	return /** @type {LocalizedString} */ ("Consommation électrique")
});
export { br_history_key_elecconso1 as "br_history_key_elecConso" }